<template>
  <v-container>
    <div class="grey--text mb-5 text-h4">About us</div>
  </v-container>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>
</style>
